<template>
  <div class="modal-mask">
    <section class="modal reduced">
      <!-- HEAD ADD NEW DISCOUNT COUPON -->
      <div class="content">
        <h1 v-if="parMethod=='add_discount'">{{$t('manageSingleDiscount.addTitle')}}</h1>
        <h1 v-if="parMethod=='modify_discount'">{{$t('manageSingleDiscount.modifyTitle')}}</h1>
        <h1 v-if="parMethod=='consult_discount'">{{$t('manageSingleDiscount.consultTitle')}}</h1>
      </div>
      <hr>
      <div class="content">
        <div class="spacer-10"></div>
        <p class="accentuate">{{$t('associateProduct.title')}}</p>
        <div class="spacer-10"></div>
        <div class="spacer-10"></div>
        <label>{{$t('products.productName')}}</label>
        <div class="row">
          <div class="demiRow">
            <!-- product selection-->
            <select
              v-model="discount['product-id']"
              :class="{ 'error' : !isProductSelected&&isSubmitted }"
            >
              <option
                v-for="product in products"
                :key="product.id"
                :value="product.id"
              >{{product['sales-channel-name']}} | {{product.name}}</option>
            </select>
            <p
              class="errorSentence"
              v-if="!isProductSelected&&isSubmitted"
            >&nbsp;{{$t('manageSingleDiscount.errorDiscountProduct')}}</p>
          </div>
          <p class="tips">{{$t('products.productNameTips')}}</p>
        </div>
        <div class="row">
          <p class="tips">{{$t('associateProduct.notFoundProduct')}}</p>
          <a @click="addNewProduct = true">{{$t('associateProduct.addProduct')}}</a>
        </div>
        <div class="spacer-10"></div>
        <label>{{$t('associateProduct.promotionType')}}</label>

        <!-- discount type and value -->
        <!-- IN %-->
        <div class="row">
          <input
            type="radio"
            v-model="discount['discount-type']"
            value="0"
          >
          <label>{{$t('associateProduct.promotionInPercentage')}}</label>
          <div
            class="dataEndInput"
            v-if="discount['discount-type'] == 0"
          >
            <p>%</p>
            <input
              type="number"
              min="0"
              max="100"
              step="1"
              v-model="discountValue"
              :class="{ 'error' : !discountValueFormat&&isSubmitted }"
            >
          </div>
          <p
            class="errorSentence"
            v-if="!discountValueFormat&&isSubmitted&&discount['discount-type'] == 0"
          >&nbsp;{{$t('manageSingleDiscount.errorDiscountValuePercentage')}}</p>
        </div>
        <!-- IN CURRENCY-->
        <div class="row">
          <input
            type="radio"
            v-model="discount['discount-type']"
            value="1"
          >
          <label>{{$t('associateProduct.promotionInValue')}}</label>
          <div
            class="dataEndInput"
            v-if="discount['discount-type'] == 1"
          >
            <p>€</p>
            <input
              type="number"
              min="0"
              class="sInput"
              v-model="discountValue"
              :class="{ 'error' : !discountValueFormat&&isSubmitted }"
            >
          </div>
          <p
            class="errorSentence"
            v-if="!discountValueFormat&&isSubmitted&&discount['discount-type'] == 1"
          >&nbsp;{{$t('manageSingleDiscount.errorDiscountValueCurrency')}}</p>
        </div>
        <br>
        <!-- Description de la réduction -->
        <label>{{$t('associateProduct.discountDesc')}}</label>
        <div class="spacer-10"></div>
        <span
          class="errorSentence"
          v-if="!frDescriptionFilled && isSubmitted"
        >* {{$t('error.textFieldRequired')}}</span>
        <div class="row">
          <div
            @click="changeLang(item.lang)"
            class="sFormBox pointer"
            :class="{ blueSelect: currentLang == item.lang }"
            v-for="item in discountDescriptions"
            :key="item.lang"
          >{{item.lang}}</div>
          <div
            class="sFormBox pointer"
            @click="newLang = true"
          >{{$t('associateProduct.add')}}</div>
          <AddLang
            v-if="newLang"
            @close="newLang = false"
            @add="getNewLang"
          ></AddLang>
        </div>
        <div class="spacer-10"></div>

        <div class="row alignCenter">
          <div class="demiRow">
            <textarea
              rows="3"
              v-model="discountDescriptions[currentLang].description"
              :class="{ 'error' : !frDescriptionFilled&&isSubmitted  }"
            ></textarea>
          </div>
          <p class="tips">{{$t('associateProduct.couponDescFieldTips')}}</p>
        </div>
      </div>
      <hr>
      <div class="content">
        <div class="row">
          <button @click="confirmNewDiscount()">{{$t('button.validate')}}</button>
          <a @click="$emit('close')">{{$t('button.cancel')}}</a>
        </div>
      </div>
    </section>
    <AddProduct
      v-if="addNewProduct == true"
      @close="addNewProduct = false"
      @newproduct="newProductAdded()"
      @click="addNewProduct = true"
    ></AddProduct>
  </div>
</template>

<script>
import AddLang from "@/components/campaigns/manageCampaign/AddLang";
import AddProduct from "@/components/products/AddInBox";
import getProducts from "@/mixins/getProducts";
import DiscountDetails from "@/services/DiscountDetails";

export default {
  props: ["parGroupOfDiscounts", "parMethod", "parDiscount","parDiscountDescriptions"],
  mixins: [getProducts],
  components: { AddLang, AddProduct },
  data() {
    return {
      isSubmitted: false,
      currentLang: this.$t("lang.fr.title"),
      newLang: false,
      addNewProduct: false,
      discountValue: "",
      discount: {
        id: "",
        "product-id": "",
        "group-of-discounts-id": "",
        "discount-type": 0,
        "discount-value": "",
        "discount-currency": "EUR",
        "discount-details": []
      },
      discountDescriptions: {
        Français: {
          lang: this.$t("lang.fr.title"),
          code: this.$t("lang.fr.code"),
          description: "",
          id: ""
        }
      }
    };
  },
  computed: {
    discountValueFormat: function() {
      // If string empty
      if (this.discountValue == "") return false;
      //convert to number
      var value = parseFloat(this.discountValue);
      //check percentage
      if (this.discount["discount-type"] == 0) {
        if (value <= 100 && value >= 0 && Number.isInteger(value)) return true;
        //check currency
      } else {
        if (value >= 0) return true;
      }
      return false;
    },
    isProductSelected: function() {
      if (this.discount["product-id"] == "") return false;
      return true;
    },
    frDescriptionFilled: function() {
      if (this.discountDescriptions[this.$t("lang.fr.title")].description)
        return true;
      return false;
    }
  },
  mounted() {
    if (
      this.parMethod == "modify_discount" ||
      this.parMethod == "consult_discount"
    ) {
      this.discount = this.parDiscount;
      if (this.discount["discount-type"] == 1)
        this.discountValue = this.discount["discount-value"] / 100;
      else this.discountValue = this.discount["discount-value"];
      if(this.parDiscountDescriptions){
        this.discountDescriptions = this.parDiscountDescriptions;
      }else{
        DiscountDetails.get(this.discount.id).then(
        res => {
          if (res.status == 200) {
            var languages = Object.keys(this.$t("lang"));
            var objectToAdd = "";
            for (let i = 0; i < languages.length; i++) {
              objectToAdd = res.data.find(x => {
                if (x.language == this.$t("lang")[languages[i]].code) return x;
              });
              if (objectToAdd != null) {
                this.discountDescriptions[
                  this.$t("lang")[languages[i]].title
                ] = {};
                this.discountDescriptions[this.$t("lang")[languages[i]].title][
                  "lang"
                ] = this.$t("lang")[languages[i]].title;
                this.discountDescriptions[this.$t("lang")[languages[i]].title][
                  "code"
                ] = objectToAdd.language;
                this.discountDescriptions[this.$t("lang")[languages[i]].title][
                  "description"
                ] = objectToAdd.description;
                this.discountDescriptions[this.$t("lang")[languages[i]].title][
                  "id"
                ] = objectToAdd.id;
              }
            }
          }
        },
        res => {
          if (res.response.status == 404) console.log("no discount");
        }
      );
      }
      
    }
    this.getProducts();
  },
  methods: {
    newProductAdded() {
      this.addProduct = false;
      this.getProducts();
    },
    confirmNewDiscount() {
      this.isSubmitted = true;
      if (!this.frDescriptionFilled)
        this.currentLang = this.$t("lang.fr.title");
      if (
        this.isProductSelected &&
        this.discountValueFormat &&
        this.frDescriptionFilled
      ) {
        
        this.discount["discount-value"] = this.discountValue;
        var returnedData = {};
        returnedData.groupOfDiscounts = this.parGroupOfDiscounts;
        returnedData.discount = this.discount;
        returnedData.discountDescriptions = this.discountDescriptions;
        if (this.parMethod == "modify_discount")
          returnedData.method = "modify_discount";
        if (this.parMethod == "add_discount")
          returnedData.method = "add_discount";
        this.$emit("operationondiscountdone", returnedData);
        this.$emit("close");
      }
    },
    changeLang(data) {
      this.currentLang = data;
    },
    getNewLang(data) {
      this.newLang = false;
      if (data.lang.title) {
        /* add the new lang or update an existing lang */
        if (this.discountDescriptions[data.lang.title])
          if (this.discountDescriptions[data.lang.title]["id"])
            data.id = this.discountDescriptions[data.lang.title]["id"];
        this.discountDescriptions[data.lang.title] = {
          lang: data.lang.title,
          code: data.lang.code,
          description: data.description,
          id: data.id
        };
        this.currentLang = data.lang.title;
      }
    }
  }
};
</script>